export default "__VITE_ASSET__DaiteLbP__"